<template>
    <div id="home-view">
        <div id="logo"><img src="@/assets/login.png" /></div>

        <div id="modules">
            <!-- <div id="title"><h2>Actions</h2></div> -->
            <LoadingDots v-if="isLoading" />
            <div class="module" v-if="!isLoading && settings.mod_validation_enable === '1'">
                <a href="/validation">
                    <div>
                        <svg
                            aria-hidden="true"
                            data-icon="check"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                        >
                            <path
                                d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                            />
                        </svg>
                    </div>
                    <div class="module-name">Validation</div>
                </a>
            </div>

            <div class="module" v-if="!isLoading && settings.mod_export_enable === '1'">
                <a href="/export">
                    <div>
                        <svg
                            aria-hidden="true"
                            data-icon="file-export"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 576 512"
                        >
                            <path
                                d="M384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128zM571 308l-95.7-96.4c-10.1-10.1-27.4-3-27.4 11.3V288h-64v64h64v65.2c0 14.3 17.3 21.4 27.4 11.3L571 332c6.6-6.6 6.6-17.4 0-24zm-379 28v-32c0-8.8 7.2-16 16-16h176V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V352H208c-8.8 0-16-7.2-16-16z"
                            />
                        </svg>
                    </div>
                    <div class="module-name">Export</div>
                </a>
            </div>

            <div
                class="module"
                v-if="
                    !isLoading &&
                        (isRattacher || isAdmin) &&
                        settings.mod_rattachment_enable === '1'
                "
            >
                <a href="/rattachment">
                    <div>
                        <svg
                            aria-hidden="true"
                            data-icon="arrows-alt-h"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                        >
                            <path
                                d="M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z"
                            />
                        </svg>
                    </div>
                    <div class="module-name">Rattachement classique</div>
                </a>
            </div>

            <div
                class="module"
                v-if="
                    !isLoading &&
                        (isRattacher || isAdmin) &&
                        settings.mod_rattachment_enable === '1'
                "
            >
                <a href="/rattachmentinverse">
                    <div>
                        <svg
                            aria-hidden="true"
                            data-icon="arrows-alt-h"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                        >
                            <path
                                d="M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z"
                            />
                        </svg>
                    </div>
                    <div class="module-name">Rattachement inverse</div>
                </a>
            </div>

            <div class="module" v-if="!isLoading && isAdmin">
                <a href="/config">
                    <div>
                        <svg
                            aria-hidden="true"
                            data-icon="cogs"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 640 512"
                        >
                            <path
                                d="M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"
                            />
                        </svg>
                    </div>

                    <div class="module-name">Administration</div>
                </a>
            </div>

            <div class="module" v-if="!isLoading">
                <a href="/help">
                    <div>
                        <svg
                            aria-hidden="true"
                            data-icon="question"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 384 512"
                        >
                            <path
                                d="M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"
                            />
                        </svg>
                    </div>
                    <div class="module-name">Aide</div>
                </a>
            </div>

            <div class="module" v-if="!isLoading" @click="logout">
                <a href="#">
                    <div>
                        <svg
                            aria-hidden="true"
                            data-icon="sign-out-alt"
                            class="svg-inline--fa fa-sign-out-alt fa-w-16"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                        >
                            <path
                                d="M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"
                            />
                        </svg>
                    </div>
                    <div class="module-name">Déconnexion</div>
                </a>
            </div>
        </div>

        <div id="copyright">
            Développé par
            <a class="colink" href="https://www.geonov.fr/" target="_blank">Geonov</a> sous
            <a href="https://www.gnu.org/licenses/gpl-3.0.html" target="_blank" class="colink"
                >Licence publique générale GNU 3.0</a
            >.
        </div>

        <LogoutModal
            v-if="showCloseConfirm"
            @dismiss="showCloseConfirm = false"
            @close="handlelogout"
        >
            <span slot="header">Se déconnecter</span>
            <span slot="body">Voulez-vous vous déconnecter de l'application ?</span>
        </LogoutModal>
    </div>
</template>

<script>
import LoadingDots from '@/components/LoadingDots';
//import LogoutLink from '@/components/LogoutLink';
//import ActionLink from '@/components/ActionLink';
import { authenticationService } from '@/services';
import { Role } from '@/helpers';
import LogoutModal from '@/components/LogoutModal';

export default {
    data() {
        return {
            showCloseConfirm: false,
            isLoading: true,
            settings: {
                mod_validation_enable: null,
                mod_export_enable: null,
                mod_rattachment_enable: null,
            },
            loaded_settings: [],
            user: authenticationService.currentUserValue,
        };
    },
    mounted() {
        this.loadSettings();
    },
    methods: {
        loadSettings() {
            this.$http
                .get('/api/setting/')
                .then(
                    (response) => {
                        const settings = response.body;
                        this.loaded_settings = settings;
                        settings.forEach((s) => (this.settings[s.name] = s.value));
                    },
                    (response) => {
                        // error callback
                        console.log(JSON.stringify(response));
                    },
                )
                .finally(() => (this.isLoading = false));
        },
        logout() {
            this.showCloseConfirm = true;
        },
        handlelogout() {
            authenticationService.logout();
            this.$router.push('/login');
        },
    },
    components: {
        //LogoutLink,
        //ActionLink,
        LoadingDots,
        LogoutModal,
    },
    computed: {
        isAdmin() {
            return this.user.role === Role.Admin;
        },
        isRattacher() {
            return this.user.role === Role.Rattacher;
        },
    },
};
</script>

<style lang="scss">
#home-view {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #f8f8f8;
    width: 100vw;
    height: 100vh;

    #logo {
        padding-bottom: 52px;
    }

    #modules {
        // height: 386px;
        min-width: 100px;
        max-width: 500px;
        border-radius: 5px;
        border-top: 5px solid #6c3e91;
        background-color: #ffffff;
        box-shadow: 0 0 7px 2px rgba(207, 207, 207, 0.5);
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;

        a {
            font-size: 16px;
            text-align: center;
            padding-top: 10px;
            color: rgb(44, 62, 80);
            text-decoration: none;
        }
    }

    #copyright {
        margin-top: 20px;
        text-align: center;
        .colink {
            text-decoration: none;
            color: #6c3e91;
        }
    }

    .module {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 30px;

        a:hover .module-name {
            color: #6c3e91;
            font-weight: 600;
        }
        a:hover svg {
            fill: #6c3e91;
        }

        svg {
            width: 100px;
            height: 100px;
            fill: #000000c4;
        }
    }

    .module-name {
        font-size: 16px;
        text-align: center;
        padding-top: 10px;
        color: rgb(44, 62, 80);
    }

    /*     #title {
        width: 100%;
        text-align: center;
        padding: 48px;
        color: #2a2a2a;
        font-size: 22px;
        font-weight: 600;
        line-height: 26px;
    } */
}
</style>
